module.exports = "../../../../platform/assets/pageMainIcon/business_jichudanganlei7.svg";